import { inject, Injectable } from "@angular/core";

import { catchError, Observable, of } from "rxjs";

import { environment } from "@environments/environment";
import { RequestState, SentinelProfileResponse } from "@shared/models";
import { ApiCacheService } from "@shared/services/util/api-cache.service";
import { GlobalService } from "@shared/services";

@Injectable({
  providedIn: "root",
})
export class SentinelProfileService {
  apiCacheService = inject(ApiCacheService);
  globalService = inject(GlobalService);

  private readonly _baseUrl = environment.myTripUrl;

  getSentinelProfile(forceRefresh: boolean, emulatedUser: string): Observable<RequestState<SentinelProfileResponse>> {
    const currentDate = new Date().toISOString().split("T")[0];
    const config = {
      cacheId: `seq-his-sentinelProfile/${emulatedUser}`,
      cacheValidMinutes: 100,
      url: `${this._baseUrl}SentinelProfile/${currentDate}/${emulatedUser}`,
      forceRefresh,
    };
    return this.apiCacheService.request<SentinelProfileResponse>(config).pipe(
      catchError((error) => {
        if (error.status === 500) {
          this.globalService.emulatedUser.set("");
          return of({} as RequestState<SentinelProfileResponse>);
        }
        return of({} as RequestState<SentinelProfileResponse>);
      })
    );
  }
}
